import { useQuery } from '@tanstack/vue-query'
import type { ComputedRef, Ref } from 'vue'
import { computed } from 'vue'

import { getMatchingExplanationBetweenMentorAndMentee } from '@/features/admin/groups/api'

const useMatchingExplanation = (
  menteeIdRef: ComputedRef<string | null> | Ref<string | null>,
  groupIdRef: ComputedRef<string | null> | Ref<string | null>,
) => {
  const isMatchingExplanationQueryEnabledRef = computed(() => !!menteeIdRef.value && !!groupIdRef.value)

  const { data, isPending } = useQuery({
    queryKey: ['matchingExplanation', { menteeId: menteeIdRef, groupId: groupIdRef }],
    queryFn: () =>
      getMatchingExplanationBetweenMentorAndMentee({ menteeId: menteeIdRef.value!, groupId: groupIdRef.value! }),
    enabled: isMatchingExplanationQueryEnabledRef,
  })

  const matchingExplanationRef = computed(() => data.value)

  return {
    matchingExplanationRef,
    isPendingRef: isPending,
  }
}

export default useMatchingExplanation
